// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1MQWj","emails":"CreateEditClinics_emails__2U5Wb","emailTagLabel":"CreateEditClinics_emailTagLabel__1vV8L"};